import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type CheckCircleActiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function CheckCircleActiveIcon({
  className,
  pathClassName = "fill-white",
  ...props
}: CheckCircleActiveIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className={className}
      {...props}
      fill="none"
    >
      <Path
        d="M12 1.75A10.25 10.25 0 1022.25 12 10.26 10.26 0 0012 1.75zm5.07 8.34l-5.37 5.37a1.83 1.83 0 01-.65.44c-.497.2-1.053.2-1.55 0a2 2 0 01-.65-.44L6.19 12.8a1.001 1.001 0 111.41-1.42l2.67 2.67 5.38-5.37a1 1 0 011.42 0 1 1 0 010 1.38v.03z"
        fill="#000"
        className={pathClassName}
      />
    </Svg>
  );
}

export default CheckCircleActiveIcon;
